import React, { useState, useEffect, useCallback } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { CreateTable } from "./../ManageTable";
import {
  CreateButton,
  CreateSearchBarWithPlaceHolder,
} from "./../CommonObjects";
import { CreateTableForEmployeeSelect } from "./../ManageTable";
import loadingSpinner from "./../../assets/loading.gif";
import axios from "axios";
import { token, domain } from "./../Security";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {globalTimeFormat} from '../Security';
import * as XLSX from "xlsx";
import { useTable, useSortBy } from "react-table";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

function OffsetCredits({ user, userAccess, isHideSideMenu }) {
  const [employee, setEmployee] = useState(
    user.employeePersonalInformationFullName
  );
  const [employeeId, setEmployeeId] = useState(
    user.employeePersonalInformationId
  );
  var isNewFunc = true;


  const [loading, setLoading] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);

  const [selectedTab, setSelectedTab] = useState(0);
  const [currentPage_overtime, setCurrentPage_overtime] = useState(1);
  const [currentPage_leave, setCurrentPage_leave] = useState(1);
  const [currentPage_holiday, setCurrentPage_holiday] = useState(1);

  const [offsetDate, setOffsetDate] = useState([]);
  const [overtimeData, setOvertimeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [holidayData, setHolidayData] = useState([]);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  var header_date = [
    "Employee Id",
    "Employee",
    "Date",
    "Time In",
    "Time Out",
    "Is Used?",
    //"",
  ];
  var accessor_date = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "timeIn",
    "timeOut",
    "isUsed",
    //"manage",
  ];

  var header_overtime = [
    "Employee Id",
    "Employee",
    "Date",
    "Hours Exceeded",
    "Used",
    "On Hold",
    "Remaining",
  ];
  var accessor_overtime = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "hours",
    "useValue",
    "holdValue",
    "remainingValue",
  ];

  var header_leave = [
    "Employee Id",
    "Employee",
    "Leave Type",
    "Date From",
    "Date To",
    "Days",
    "Used",
    "On Hold",
    "Remaining",
  ];
  var accessor_leave = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "leaveData.leaveTypeDescription",
    "leaveData.dateFrom",
    "leaveData.dateTo",
    "leaveData.days",
    "useValue",
    "holdValue",
    "remainingValue",
  ];

  var header_holiday = [
    "Employee Id",
    "Employee",
    "Date",
    "Days",
    "Used",
    "On Hold",
    "Remaining",
  ];
  var accessor_holiday = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "days",
    "useValue",
    "holdValue",
    "remainingValue",
  ];

  const handleSelectChange = (index) => {
    setCurrentPage_overtime(1);
    setCurrentPage_leave(1);
    setCurrentPage_holiday(1);
    setSelectedTab(index);
  };

  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };

  const fetchDataOvertime = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetOvertime/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  const fetchDataLeave = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetLeave/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  const fetchDataHoliday = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetHoliday/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  const fetchDataCredit = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetRequest/credit/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  

  const generateData = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetRequest/generate-offset/employee/${employeeId}`;

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data
    } catch (error) {
      console.error("Error fetching data:", error);
      return null
    }
  }, [employeeId]);

  const generateNewData = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetRequest/generate-offset-date/employee/${employeeId}/selection/${false}`;

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      const filtered = response.data.filter(i => {
        return (new Date(i.timeOut).getHours() >= 22 || new Date(i.timeOut).getHours() < 6)
      })

      console.log({filtered})

      return filtered
    } catch (error) {
      console.error("Error fetching data:", error);
      return null
    }
  }, [employeeId]);

  const fetchDataOld = useCallback(async () => {
    setLoading(true);

    await generateData();

    const isNew = true;

    if(isNew){
      const _data = await fetchDataCredit();

      setOvertimeData(_data.overtimeData);
      setLeaveData(_data.leaveData);
      setHolidayData(_data.holidayData);
    } else {
      const _overtimeData = await fetchDataOvertime();
      const _leaveData = await fetchDataLeave();
      const _holidayData = await fetchDataHoliday();

      setOvertimeData(_overtimeData);
      setLeaveData(_leaveData);
      setHolidayData(_holidayData);
    }

    setLoading(false);
  }, [fetchDataCredit, fetchDataOvertime, fetchDataLeave, fetchDataHoliday, generateData]);

  const fetchData = useCallback(async () => {
    setLoading(true);

    if(isNewFunc)
    {
      const _data = await generateNewData();

      setOffsetDate(_data)
    } else {
      const _data = await generateData();
      
      setOvertimeData(_data?.overtimeData ?? []);
      setLeaveData(_data?.leaveData ?? []);
      setHolidayData(_data?.holidayData ?? []);
    }

    setLoading(false);
  }, [generateData, generateNewData, isNewFunc]);

  /* const fetchData = useCallback(async () => {
  }, []); */

  // const [isGenerate, setIsGenerate] = useState(true);

  const generate = () => {
    // setIsGenerate(true);
    fetchData();
  };

  useEffect(()=>{
    fetchData();
  }, [fetchData])

  useEffect(()=>{
    const test = false;

    if(test){
      fetchDataOld();
    }
  }, [fetchDataOld])

  /* useEffect(() => {
    if (isGenerate) {
      fetchData();
      setIsGenerate(false);
    }
  }, [isGenerate, fetchData]); */

  var generateDLTemplate = async () => {
    if(isNewFunc)
    {
      await generateDownloadTemplateNew()
    } else {
      await generateDownloadTemplate()
    }
  } 

  const generateDownloadTemplate = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("Offset_Template");

    worksheet1.columns = [
      { header: "EmployeeId", key: "employeeId", width: 30 },
      { header: "EmployeeName", key: "employeeName", width: 30 },
      { header: "Date", key: "date", width: 30 },
      { header: "Value", key: "value", width: 30 },
      { header: "Type", key: "type", width: 30 },
    ];

    const headerRow = worksheet1.getRow(1);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    // Force Date column format
    worksheet1.getColumn(3).numFmt = "mm-dd-yyyy";

    // Apply Date validation to many rows (e.g., 1000 rows)
    for (let i = 2; i <= 1000; i++) {
      worksheet1.getCell(`C${i}`).dataValidation = {
        type: "date",
        operator: "greaterThan",
        allowBlank: false,
        showErrorMessage: true,
        formulae: [new Date(1900, 0, 1)],
        errorStyle: "error",
        errorTitle: "Invalid Date",
        error: "Please enter a valid date (MM-DD-YYYY).",
      };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Offset_Credit_Template.xlsx");
  }, []);

  const generateDownloadTemplateNew = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("Offset_Template");

    worksheet1.columns = [
      { header: "EmployeeId", key: "employeeId", width: 30 },
      { header: "EmployeeName", key: "employeeName", width: 30 },
      { header: "Date", key: "date", width: 30 },
      { header: "TimeIn", key: "timeIn", width: 30 },
      { header: "TimeOut", key: "timeOut", width: 30 },
    ];

    const headerRow = worksheet1.getRow(1);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    // Force Date column format
    worksheet1.getColumn(3).numFmt = "mm-dd-yyyy";
    worksheet1.getColumn(4).numFmt = "hh:mm"; // TimeIn
    worksheet1.getColumn(5).numFmt = "hh:mm"; // TimeOut

    // Apply Date validation to many rows (e.g., 1000 rows)
    for (let i = 2; i <= 1000; i++) {
      worksheet1.getCell(`C${i}`).dataValidation = {
        type: "date",
        operator: "greaterThan",
        allowBlank: false,
        showErrorMessage: true,
        formulae: [new Date(1900, 0, 1)],
        errorStyle: "error",
        errorTitle: "Invalid Date",
        error: "Please enter a valid date (MM-DD-YYYY).",
      };
      // TimeIn validation (FIXED)
      worksheet1.getCell(`D${i}`).dataValidation = {
        type: "decimal",
        operator: "between",
        allowBlank: false,
        showErrorMessage: true,
        formulae: [0, 0.99999],
        errorTitle: "Invalid Time",
        error: "Please enter a valid time (HH:MM).",
      };

      // TimeOut validation (FIXED)
      worksheet1.getCell(`E${i}`).dataValidation = {
        type: "decimal",
        operator: "between",
        allowBlank: false,
        showErrorMessage: true,
        formulae: [0, 0.99999],
        errorTitle: "Invalid Time",
        error: "Please enter a valid time (HH:MM).",
      };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Offset_Credit_Template.xlsx");
  }, []);

  const [showUploadForm, setshowUploadForm] = useState(false);

  const openUploadForm = () => {
    setshowUploadForm(true);
  }

  const closeUploadForm = () => {
    setshowUploadForm(false);
  }

  const fetchDataForEmployee = useCallback(async () => {
      const apiUrl =  domain + `/api/Employee/single-data`;

      try {
          const response = await axios.get(apiUrl, user, {
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
          }})
          return response.data;
      } catch (error) {
          console.error('Error fetching data:', error);
          return [];
      }
  }, [user]);

  const [uploadData, setUploadData] = useState([]);
  const uploadEmployeeData = async (file) => {
    setLoading(true);
    const dataEmployee = await fetchDataForEmployee();

    function sanitizeValue(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return "";
      }
      return value;
    }
    function sanitizeValueInteger(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return 0;
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push("Employee Id");
        if (!item.type) missing.push("Type");

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(
          (employee) => employee.employeeId === item.employeeId?.toString()
        );
        if (!existingEmployee) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Employee Id does not exist.`
              : `Employee Id does not exist. `;
        }

        if (!Number.isFinite(item.value)) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Invalid value - Value.`
              : `Invalid value - Value. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(", ")}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      };

      const informations = parseWorksheet(
        workbook.Sheets[workbook.SheetNames[0]]
      );

      let bulkData = [];

      informations.forEach((info) => {
        let foundEmployee = null;

        foundEmployee = dataEmployee.find(
          (data) =>
            data.employeeId.toLowerCase() ===
            sanitizeValue(info.EmployeeId).toString().toLowerCase()
        );

        function formatToYYYYMMDD(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          return `${year}-${month}-${day}`;
        }

        function excelSerialToDate(serial) {
          const excelEpoch = new Date(1899, 11, 31);
          return new Date(excelEpoch.getTime() + serial * 86400000);
        }

        let formattedDate = null;

        if (info.Date) {
          const realDate = excelSerialToDate(info.Date);
          formattedDate = formatToYYYYMMDD(realDate);
        }

        // i will use the locations, employments etc. here below
        bulkData.push({
          employeeId: sanitizeValue(info.EmployeeId),
          fullName: sanitizeValue(info.EmployeeName),
          employeePersonalInformationId: foundEmployee
            ? sanitizeValue(foundEmployee.id)
            : 0,
          date: formattedDate ? sanitizeValue(formattedDate) : null,
          value: info.Value ? sanitizeValueInteger(info.Value) : 0,
          type: sanitizeValue(info.Type),
        });
      });

      console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));

      // Validate the bulk data
      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadData(sortedData);
    };

    setLoading(false);
    reader.readAsArrayBuffer(file);
  };
  const uploadEmployeeDataNew = async (file) => {
    setLoading(true);
    const dataEmployee = await fetchDataForEmployee();

    function sanitizeValue(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return "";
      }
      return value;
    }

    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push("Employee Id");

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(
          (employee) => employee.employeeId === item.employeeId?.toString()
        );
        if (!existingEmployee) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Employee Id does not exist.`
              : `Employee Id does not exist. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(", ")}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      };

      const informations = parseWorksheet(
        workbook.Sheets[workbook.SheetNames[0]]
      );

      let bulkData = [];

      informations.forEach((info) => {
        let foundEmployee = null;

        foundEmployee = dataEmployee.find(
          (data) =>
            data.employeeId.toLowerCase() ===
            sanitizeValue(info.EmployeeId).toString().toLowerCase()
        );

        function formatToYYYYMMDD(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          return `${year}-${month}-${day}`;
        }

        function excelSerialToDate(serial) {
          const excelEpoch = new Date(1899, 11, 31);
          return new Date(excelEpoch.getTime() + serial * 86400000);
        }

        function formatToISO(dateSerial, timeSerial) {
          // 1. Get the base date from Excel serial
          const baseDate = excelSerialToDate(dateSerial);
          
          // 2. Extract hours and minutes
          const totalSeconds = Math.round(timeSerial * 86400);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);

          // 3. Construct the local date string manually to avoid UTC conversion
          const year = baseDate.getFullYear();
          const month = String(baseDate.getMonth() + 1).padStart(2, "0");
          const day = String(baseDate.getDate()).padStart(2, "0");
          const h = String(hours).padStart(2, "0");
          const m = String(minutes).padStart(2, "0");

          // Format: YYYY-MM-DDTHH:mm:ss
          // No "Z" at the end means it's treated as local time by .NET
          return `${year}-${month}-${day}T${h}:${m}:00`;
        }

        let formattedDate = null;
        let formattedTimeIn= null;
        let formattedTimeOut = null;

        if (info.Date) {
          const realDate = excelSerialToDate(info.Date);
          formattedDate = formatToYYYYMMDD(realDate);

          // Process TimeIn using the same Date
          if (info.TimeIn) {
            formattedTimeIn = formatToISO(info.Date, info.TimeIn);
          }

          // Process TimeOut using the same Date
          if (info.TimeOut) {
            formattedTimeOut = formatToISO(info.Date, info.TimeOut);
          }
        }

        // i will use the locations, employments etc. here below
        bulkData.push({
          employeeId: sanitizeValue(info.EmployeeId),
          fullName: sanitizeValue(info.EmployeeName),
          employeePersonalInformationId: foundEmployee
            ? sanitizeValue(foundEmployee.id)
            : 0,
          date: formattedDate ? sanitizeValue(formattedDate) : null,
          timeIn: formattedTimeIn ? sanitizeValue(formattedTimeIn) : null,
          timeOut: formattedTimeOut ? sanitizeValue(formattedTimeOut) : null,
          isUsed: false
        });
      });

      console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));

      // Validate the bulk data
      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadData(sortedData);
    };

    setLoading(false);
    reader.readAsArrayBuffer(file);
  };
  function handleFileUpload(files) {
    if (!files || files.length === 0) {
      console.error("No files selected");
      return;
    }

    const file = files[0];

    if(isNewFunc){
      uploadEmployeeDataNew(file);
    } else {
      uploadEmployeeData(file);
    }
  }
  const handleFinalFileUpload = async (bulkData) => {
    setLoading(true);

    const apiUrl = `${domain}/api/OffsetRequest/upload`;

    try {
      const response = await axios.post(apiUrl, bulkData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Upload successful:", response.data);
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleFinalFileUploadNew = async (bulkData) => {
    setLoading(true);

    const apiUrl = `${domain}/api/OffsetRequest/upload-date`;

    try {
      const response = await axios.post(apiUrl, bulkData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Upload successful:", response.data);
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
          <div className="LeftSpace"></div>
          <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
            <div className="TransactionInfo Transaction-Form-Info">
              <div className="transaction-header">
                <div className="sub-title row">
                  <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                    {"Transactions >"}{" "}
                  </span>
                  <span style={{ borderBottom: "1px solid black" }}>
                    {"Offset Credits"}
                  </span>
                </div>
                <div
                  className="row"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h3>Offset Credits</h3>
                </div>
              </div>
              <div className="transaction-body loan-tab">
                <div
                  className="transaction-from-splitItem row"
                  style={{ alignItems: "center" }}
                >
                  <div className="column" style={{ width: "100%" }}>
                    <div className="transaction-form-item row">
                      <div
                        className="transaction-form-category"
                        style={{ width: "90px" }}
                      >
                        <h4>Employee</h4>
                      </div>
                      <div className="transaction-form-input">
                        <div
                          className="info-item-holder employee-select row"
                          style={{
                            flexDirection: "row",
                            justifyContent: "normal",
                          }}
                        >
                          <input
                            readOnly
                            className="employeeInput-select"
                            placeholder="Employee"
                            value={employee ? employee : employee}
                          />
                          <button
                            className="select row"
                            onClick={() => setShowEmployeeForm(true)}
                            style={{
                              visibility:
                                userAccess.description === "Admin" ||
                                userAccess.description === "HR Head" ||
                                userAccess.description === "HR Assistant" ||
                                userAccess.description === "HR Assistant2" ||
                                userAccess.description === "HR Assistant3" ||
                                userAccess.description === "HR Manager"
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            <SearchIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="column" style={{ width: "100%"}}>
                    <div
                      className="generate-button-offset"
                      style={{visibility: "hidden"}}
                    >
                      {CreateButton(
                        "overtime-add-button",
                        "submit",
                        generate,
                        "GENERATE",
                        ""
                      )}
                    </div>
                  </div>
                </div>


                {user?.accessTemplateDescription === "Admin" && 
                  <div className="flex flex-row gap-2 items-center" style={{ padding: "10px 0"}}>
                    <div
                      className="download-button-offset"
                    >
                      {CreateButton(
                        "overtime-add-button",
                        "submit",
                        generateDLTemplate,
                        "DOWNLOAD TEMPLATE",
                        ""
                      )}
                    </div>
                    <div
                      className="generate-button-offset"
                    >
                      {CreateButton(
                        "overtime-add-button",
                        "submit",
                        openUploadForm,
                        "UPLOAD DATA",
                        ""
                      )}
                    </div>
                  </div>
                }

                <div className="mt-10 hidden" >
                  <Tabs
                    selectedIndex={selectedTab}
                    onSelect={(index) => handleSelectChange(index)}
                  >
                    <TabList>
                      <Tab>
                        <b>OVERTIME</b>
                      </Tab>
                      <Tab>
                        <b>LEAVE</b>
                      </Tab>
                      <Tab>
                        <b>HOLIDAY</b>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <div style={{ padding: "20px 0", display: "none" }}>
                        <span
                          style={{
                            padding: "10px",
                            background: "white",
                            border: "1px solid #aaa",
                            borderRadius: "5px",
                          }}
                        >{`Offset Hours: ${overtimeData.totalHours?.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}`}</span>
                      </div>
                      <div className="transaction-table container">
                        <CreateTable
                          dataList={overtimeData?.data ?? []}
                          dataHeader={header_overtime}
                          dataAccessor={accessor_overtime}
                          // editHandleClick={editHandleClick}
                          currentPage={currentPage_overtime}
                          setCurrentPage={setCurrentPage_overtime}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div style={{ padding: "20px 0", display: "none" }}>
                        <span
                          style={{
                            padding: "10px",
                            background: "white",
                            border: "1px solid #aaa",
                            borderRadius: "5px",
                          }}
                        >{`Offset Days: ${leaveData.totalDays?.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}`}</span>
                      </div>
                      <div className="transaction-table container">
                        <CreateTable
                          dataList={leaveData?.data ?? []}
                          dataHeader={header_leave}
                          dataAccessor={accessor_leave}
                          // editHandleClick={editHandleClickBeneficiary}
                          // deleteHandleClick={deleteHandleClick}
                          currentPage={currentPage_leave}
                          setCurrentPage={setCurrentPage_leave}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div style={{ padding: "20px 0", display: "none" }}>
                        <span
                          style={{
                            padding: "10px",
                            background: "white",
                            border: "1px solid #aaa",
                            borderRadius: "5px",
                          }}
                        >{`Offset Days: ${leaveData.totalDays?.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}`}</span>
                      </div>
                      <div className="transaction-table container">
                        <CreateTable
                          dataList={holidayData?.data ?? []}
                          dataHeader={header_holiday}
                          dataAccessor={accessor_holiday}
                          // editHandleClick={editHandleClickBeneficiary}
                          // deleteHandleClick={deleteHandleClick}
                          currentPage={currentPage_holiday}
                          setCurrentPage={setCurrentPage_holiday}
                        />
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>

                <div className="transaction-table container">
                  <CreateTable
                    dataList={offsetDate ?? []}
                    dataHeader={header_date}
                    dataAccessor={accessor_date}
                    // editHandleClick={editHandleClick}
                    currentPage={currentPage_overtime}
                    setCurrentPage={setCurrentPage_overtime}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        user={user}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeeId}
        setEmployee={setEmployee}
      ></EmployeeSelectForm>

      { isNewFunc ?
        <UploadNewForm
          isOpen={showUploadForm}
          onClose={closeUploadForm}
          data_temp={uploadData}
          setData_temp={setUploadData}
          handleFileUpload={handleFileUpload}
          handleFinalFileUpload={handleFinalFileUploadNew}
        ></UploadNewForm>
      :
        <UploadForm
          isOpen={showUploadForm}
          onClose={closeUploadForm}
          data_temp={uploadData}
          setData_temp={setUploadData}
          handleFileUpload={handleFileUpload}
          handleFinalFileUpload={handleFinalFileUpload}
        ></UploadForm>
      }

      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>

      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

function EmployeeSelectForm({ isOpen, user, onClose, setEmployeeId, setEmployee }) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Employee/basic-info/all/active";

      try {
          setLoading(true);
          const response = await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
          }})
              setEmployees(response.data); // Set the response data to the state
              setFilterData(response.data); // Set the response data to the state
      } catch (error) {
          console.error('Error fetching data:', error);
      } finally {
          setLoading(false); // Set loading state to false after data fetching is complete
      }
  }
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees?.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function UploadForm({
  isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload,
}) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter((i) => i.errors.length > 0);

      if (_errorData.length <= 0) {
        setHasNoError(true);
      } else {
        setHasNoError(false);
      }
    }
  }, [data_temp]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files);
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles]);

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = ["Employee Id", "Employee Name", "Date", "Value", "Type", "Error"];
  var accessor = ["employeeId", "fullName", "date", "value", "type", "errors"];

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Data"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div
              className="popUp-body user-template-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>

            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{
                        marginRight: "5px",
                        height: "34px",
                        borderRadius: "3px",
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ? (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#4cc92a",
                        color: "white",
                      }}
                    >
                      Data is valid.
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#ce3434",
                        color: "white",
                      }}
                    >
                      Cannot upload with error.
                    </div>
                  </>
                )}
                <div
                  className="employeesTab-tab upload-preview-tab"
                  style={{ marginTop: "10px" }}
                >
                  <div
                    id="container1 table-uploads"
                    className="employeesTab-table container"
                  >
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div
                  className="buttons row"
                  style={{
                    justifyContent: "end",
                    padding: "40px 40px 20px 40px",
                  }}
                >
                  {hasNoError && (
                    <button
                      id="add-family"
                      className="save row"
                      onClick={(e) => submit(e)}
                      style={{ marginRight: "5px" }}
                    >
                      UPLOAD
                    </button>
                  )}
                  <button
                    id="add-family"
                    className="cancel row"
                    style={{
                      marginRight: "5px",
                      height: "34px",
                      borderRadius: "3px",
                    }}
                    onClick={() => handleClose()}
                  >
                    CANCEL
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
function UploadNewForm({
  isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload,
}) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter((i) => i.errors.length > 0);

      if (_errorData.length <= 0) {
        setHasNoError(true);
      } else {
        setHasNoError(false);
      }
    }
  }, [data_temp]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files);
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles]);

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = ["Employee Id", "Employee Name", "Date", "Time In", "Time Out", "Error"];
  var accessor = ["employeeId", "fullName", "date", "timeIn", "timeOut", "errors"];

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Data"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div
              className="popUp-body user-template-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>

            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{
                        marginRight: "5px",
                        height: "34px",
                        borderRadius: "3px",
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ? (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#4cc92a",
                        color: "white",
                      }}
                    >
                      Data is valid.
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#ce3434",
                        color: "white",
                      }}
                    >
                      Cannot upload with error.
                    </div>
                  </>
                )}
                <div
                  className="employeesTab-tab upload-preview-tab"
                  style={{ marginTop: "10px" }}
                >
                  <div
                    id="container1 table-uploads"
                    className="employeesTab-table container"
                  >
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div
                  className="buttons row"
                  style={{
                    justifyContent: "end",
                    padding: "40px 40px 20px 40px",
                  }}
                >
                  {hasNoError && (
                    <button
                      id="add-family"
                      className="save row"
                      onClick={(e) => submit(e)}
                      style={{ marginRight: "5px" }}
                    >
                      UPLOAD
                    </button>
                  )}
                  <button
                    id="add-family"
                    className="cancel row"
                    style={{
                      marginRight: "5px",
                      height: "34px",
                      borderRadius: "3px",
                    }}
                    onClick={() => handleClose()}
                  >
                    CANCEL
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
function CreateTableForUpload({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                className={row.original.error ? "error" : ""}
              >
                {row.cells.map((cell) => (
                  <SetInfoForUpload
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "25px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "25px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfoForUpload({ header, _cell }) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (data.photo) {
      const imageSrc = "data:image/jpeg;base64," + data.photo;

      return (
        <td>
          <img className="avatarImg" src={imageSrc} alt="" />
        </td>
      );
    }
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    );
  }

  if (header === "Date Created") {
    if (!value) {
      return <td></td>;
    }

    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if(header === "Time From"
      || header === "Time To"
      || header === "Time In"
      || header === "Time Out"
      ){
          const time = _cell.render("Cell").props.value;
          if(!time) {
              return (
                  <td>
                  </td>
              );
          }
  
          let timeParts;
          let formattedTime;
  
          if (globalTimeFormat === "Standard Time"){
              const timeSplit = time.split('T');
              if (timeSplit.length > 1) {
                  timeParts = timeSplit[1].substr(0, 5).split(':');
              } else {
                  timeParts = [];
              }
              let hours = parseInt(timeParts[0], 10);
              const minutes = timeParts[1];
  
              // Convert 24-hour format to 12-hour format and determine AM or PM
              const amPm = hours >= 12 ? 'PM' : 'AM';
              hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
  
              formattedTime = `${hours}:${minutes} ${amPm}`;
          } else if (globalTimeFormat === "Military Time"){
              const timeSplit = time.split('T');
              if (timeSplit.length > 1) {
                  timeParts = timeSplit[1].substr(0, 5).split(':');
              } else {
                  timeParts = [];
              }
              let hours = parseInt(timeParts[0], 10);
              const minutes = timeParts[1];
  
              formattedTime = `${hours}:${minutes}`;
          }
  
          return (
              <td>
                  {formattedTime}
              </td>
          );
      }

  if (header === "Error") {
    return (
      <td>{value && <p style={{ color: "red", margin: 0 }}>{value}</p>}</td>
    );
  }

  if (
    header === "Vacation Leave" ||
    header === "Sick Leave" ||
    header === "Service Incentive Leave" ||
    header === "Solo Parent Leave" ||
    header === "Vacation Leave Remaining" ||
    header === "Sick Leave Remaining" ||
    header === "Service Incentive Leave Remaining" ||
    header === "Solo Parent Leave Remaining"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}

export default OffsetCredits;
